/* eslint-disable react/prop-types */
/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import { InsightCount } from 'schemas/action/InsightCountSchema'
import { useDashboardWidgetData } from '../../../../hooks/useWidgetState'
import ErrorMessage from '../../../share/ErrorMessage'
import ReturnStatus from '../../../../enums/ReturnStatus'

const TopicLowAuthorCountGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetData = useDashboardWidgetData<InsightCount>(widgetId)
  const { t } = useTranslation()

  if (
    widgetData?.data?.[0]?.results?.[0]?.data?.insights?.[0]?.dataset?.[0]?.status ===
    ReturnStatus.LOW_AUTHOR_COUNT
  )
    return <ErrorMessage>{t('lowAuthorCount')}</ErrorMessage>

  return children
}

export default TopicLowAuthorCountGuard
